import { useEffect, useState } from 'react';
import { Modal, Typography } from 'antd';
import ProjectSplitsField from './ProjectSplitsField';

const { Text } = Typography;

const validateLocal = (splits) => {
  if (!splits || splits.length < 2)
    return 'Potrebujete vsaj dva projekta.';
  const projectIds = splits.map((s) => s.project);
  if (projectIds.some((p) => p == null))
    return 'Izberite projekt za vsako vrstico.';
  if (new Set(projectIds).size !== projectIds.length)
    return 'Projekt se pojavi večkrat.';
  const sum = splits.reduce((a, s) => a + Number(s.split_percent || 0), 0);
  if (Math.abs(sum - 100) > 0.01)
    return `Vsota odstotkov mora biti 100% (trenutno ${Math.round(sum * 100) / 100}%).`;
  return null;
};

const ProjectSplitsModal = ({
  open,
  onCancel,
  onConfirm,
  initialValue,
  amount = null,
}) => {
  const [local, setLocal] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setLocal(
        Array.isArray(initialValue) && initialValue.length > 0
          ? initialValue.map((s) => ({ ...s }))
          : [
              { project: null, split_percent: '50' },
              { project: null, split_percent: '50' },
            ]
      );
      setSaving(false);
    }
  }, [open, initialValue]);

  const error = validateLocal(local);

  const handleOk = async () => {
    setSaving(true);
    try {
      await onConfirm(local);
    } catch (e) {
      console.error('Split confirm error:', e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="Razdeli med projekte"
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Potrdi"
      cancelText="Prekliči"
      okButtonProps={{ disabled: !!error, loading: saving }}
      confirmLoading={saving}
      width={720}
      destroyOnClose
    >
      <ProjectSplitsField value={local} onChange={setLocal} amount={amount} />
      {error && (
        <Text type="danger" style={{ display: 'block', marginTop: 12 }}>
          {error}
        </Text>
      )}
    </Modal>
  );
};

export default ProjectSplitsModal;
